import React from 'react';

const AboutUsPage: React.FC = () => {
  return (
    <div
      style={{
        padding: '20px',
        textAlign: 'left',
        color: '#fff',
        backgroundColor: '#0D0713',
        minHeight: '100vh',
        fontFamily: 'Libre Franklin, sans-serif',
      }}
    >
      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        <h1>About Which Year</h1>

        <p style={{ marginBottom: '1em' }}>
          WhichYear is a game that challenges your perception of time and
          history through images!
        </p>
        <p style={{ marginBottom: '1em' }}>
          Our mission is to provide a fun, engaging, and sometimes surprisingly
          tricky way to test your ability to discern when a photograph was
          taken. Look for clues in fashion, technology, image quality, and the
          overall context of the scene.
        </p>

        <h2>How It Works</h2>
        <p style={{ marginBottom: '1em' }}>
          Each round, you're presented with a historical photograph. Your task
          is simple: guess the year it was taken! The closer your guess, the
          more points you earn. Use digit reveals to help you narrow down the
          possibilities.
        </p>
        <p style={{ marginBottom: '1em' }}>
          We feature a new Daily Challenge every day, allowing you to compete
          with others and track your performance over time. Images are often
          sourced from Wikimedia Commons and other publicly available archives,
          showcasing a wide array of historical moments and everyday life.
        </p>

        <h2>The Developer</h2>
        <p style={{ marginBottom: '1em' }}>
          This game was developed by Chris Creguer as a project to explore
          historical images in an interactive format.
        </p>

        <h2>Feedback and Contributions</h2>
        <p style={{ marginBottom: '1em' }}>
          We love hearing from our players! If you have feedback, suggestions,
          or even a great photo you think would make a good challenge, please
          don't hesitate to reach out to whichyrgame@gmail.com.
        </p>

        <p style={{ marginBottom: '1em' }}>Thanks for playing Which Year!</p>
      </div>
    </div>
  );
};
export default AboutUsPage;
